"use strict";
/// <reference path="irep.js"/> 
IREP.essentials = (function () {


    function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function init() {

        $("#gurus").css('top', $("#point").height() + $("#status").height() +185);


        $("#point").css('top', $("#status").height() + 155);
        $(".righttext").each(function () {
            var heights = $(this).closest(".greytext").height();

            $(this).css("height", heights);
        });


        if (getParameterByName('page') == 'point') {


            $(".selectedText").css("width", "170px");
            $(".selectedText").removeClass("selectedText"); 
            $("#statuslevels").hide();
            $("#points").show();
            $("#point").css('', '');
            $("#point").addClass("selectedText");
            $(".selectedText").css("width", "180px");


        }



        if (getParameterByName('page') == 'guru') {


            $(".selectedText").css("width", "170px");
            $(".selectedText").removeClass("selectedText"); 
            $("#statuslevels").hide();
            $("#gurudetails").show(); 
            $("#gurus").css('', '');
            $("#gurus").addClass("selectedText");
            $(".selectedText").css("width", "180px");


        }


        $(".badge").hover(
    function () {
        $(this).filter(':not(:animated)').animate({
            bottom: 25
        }, 250);
        // This only fires if the row is not undergoing an animation when you mouseover it
    },
    function () {
        if (!$(this).hasClass("active")) {
            $(this).animate({
                bottom: 5
            }, 250);
        }
    });

        $(".badge").click(function () {
            if (!$(this).hasClass("active")) {
                $(".active").animate({
                    bottom: 5
                }, 250);
                $(".active").removeClass("active");

                $(this).css("bottom", "25px");
                $(".boxy").fadeOut(250);
                $("#" + $(this).data("id")).delay(250).fadeIn(250);
                $(this).addClass("active");
            }
        });



        $(".badgeapac").hover(
    function () {
        $(this).filter(':not(:animated)').animate({
            bottom: 15
        }, 250);
        // This only fires if the row is not undergoing an animation when you mouseover it
    },
    function () {
        if (!$(this).hasClass("active")) {
            $(this).animate({
                bottom: -13
            }, 250);
        }
    });

        $(".badgeapac").click(function () {
            if (!$(this).hasClass("active")) {
                $(".active").animate({
                    bottom: -13
                }, 250);
                $(".active").removeClass("active");

                $(this).css("bottom", "25px");
                $(".boxy").fadeOut(250);
                $("#" + $(this).data("id")).delay(250).fadeIn(250);
                $(this).addClass("active");
            }
        });

        $(".normaltext").click(function () {
            if (!$(this).hasClass("selectedText")) {
                $(".selectedText").animate({
                    width: 170
                }, 250);
                $(".selectedText").addClass("normaltext").removeClass("selectedText");

                $(this).animate({
                    width: 180
                }, 250);
                $(this).addClass("selectedText");


                $(".fader").fadeOut(250);
                $("#" + $(this).data("id")).delay(249).fadeIn(250);

            }
        });
    }
    return {
        init: init
    };
})();